import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHsa = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9.071,19.071H6.929a2,2,0,0,1-2-2V15.757a2,2,0,0,0-.586-1.414l-.929-.929a2,2,0,0,1,0-2.828l.929-.929a2,2,0,0,0,.586-1.414V6.929a2,2,0,0,1,2-2H8.243a2,2,0,0,0,1.414-.586l.929-.929a2,2,0,0,1,2.828,0l.929.929a2,2,0,0,0,1.414.586h1.314a2,2,0,0,1,2,2V8.243a2,2,0,0,0,.586,1.414l.929.929a2,2,0,0,1,0,2.828l-.929.929a2,2,0,0,0-.586,1.414v1.314a2,2,0,0,1-2,2H15.757a2,2,0,0,0-1.414.586l-.929.929a2,2,0,0,1-2.828,0L9.071,19.071Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M13.643,8.971A2.493,2.493,0,0,1,16,11.51c0,2.485-3.929,4.52-4,4.52S8,14,8,11.51a2.493,2.493,0,0,1,2.357-2.539A2.116,2.116,0,0,1,12,9.726a2.116,2.116,0,0,1,1.643-.755Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H24V24H0Z"
		})
	]
});
export default SvgHsa;
